module.exports = __webpack_public_path__ + "assets/img/hosts.99aefe5b.svg";